// extracted by mini-css-extract-plugin
export var title = "result-module--title--QeuNH";
export var list = "result-module--list--gNLqT";